import copy from 'fast-copy';


export const sourcesReducer = (state, action) => {

  const newState = {};
  for (const key of Object.keys(action)) newState[key] = action[key];

  const finalState = copy({...state, ...newState});
  localStorage.setItem('sourcesState', JSON.stringify(
    finalState
  ));

  return finalState;
};
